<div class="d-flex flex-column">
  <h5 *ngIf="tabs?.length" class="text-center">{{ 'templates.createPage.selectPreviewMode' | transloco }}</h5>

  <app-toggle-group-with-label
    btnClasslist=""
    classList="justify-content-center"
    [groupClasslist]="'btn-group'"
    [items]="tabs"
    viewType="large"
    [defaultValue]="screenSize"
    (change)="onScreenSizeChange($event)"
  ></app-toggle-group-with-label>

  <div
    class="preview-grid mt-4"
    [class.with-loader]="loading"
    [class.with-preview-mode]="tabs?.length"
  >
    <ng-container *ngIf="!loading">
      <app-cfs-template-preview-with-header
        *ngFor="let item of items; index as i"
        class="preview-grid__item {{ screenSize }}"
        [class.selected]="selectedItemId && item.id === selectedItemId"
        [screenSize]="screenSize"
        [options]="item"
        [disabledInfo]="item.disabledInfo"
        [calcAspectRatio]="!!tabs?.length"
        (click)="clickSelectItem(item)">
      </app-cfs-template-preview-with-header>
    </ng-container>

    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"> </span>
  </div>
</div>
